export const FETCH_FOODS_REQUEST = "food/fetchRequest";
export const FETCH_FOODS_SUCCESS = "food/fetchSuccess";
export const FETCH_FOODS_FAILURE = "food/fetchFailure";
export const FETCH_FOODS_REQUEST_ASYNC = "food/fetchRequestAsync";